// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import IntegerValue from '../common/IntegerValue';
import NoDataCell from './NoDataCell';
import { InfoTooltip } from '../tooltips';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: number;
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  disclaimerKey?: string; // for trailing returns disclaimer a11y
  sectionKey?: string; // for trailing returns disclaimer a11y
  asteriskDisclaimerKey?: string; // for trailing returns disclaimer a11y
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean; // needed for non trailing returns disclaimers (calendar year returns, risk metrics, etc)
  disclaimerNumber?: number; // Sequential numbering [1], [2], [3] - used in trailing returns section
  locale?: Locale;
};

const NumberedDisclaimer = ({ disclaimerKey, disclaimerNumber, sectionKey }: { disclaimerKey?: string; disclaimerNumber?: number; sectionKey?: string }) => {
  const ariaId = `numbered-disclaimer-${disclaimerKey}-${sectionKey}-${disclaimerNumber}`;
  return (
    <sup className="disclaimer-marker">
      <a href={`#${ariaId}`} aria-describedby={ariaId}>
        {disclaimerNumber}
      </a>
    </sup>
  );
};
const AsteriskDisclaimer = ({ disclaimerKey, sectionKey }: { disclaimerKey?: string; sectionKey?: string }) => {
  const ariaId = `disclaimer-${disclaimerKey}-${sectionKey}`;
  return (
    <sup className="disclaimer-marker">
      <a href={`#${ariaId}`} aria-describedby={ariaId}>
        *
      </a>
    </sup>
  );
};

const GrowthCell: React.FunctionComponent<Props> = ({
  value,
  className,
  disclaimer,
  disclaimerKey,
  sectionKey,
  asteriskDisclaimerKey,
  valueDisclaimer,
  item,
  onClick,
  id,
  hasDisclaimer,
  disclaimerNumber,
  locale,
}: Props) => {
  if (value == null) {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  return (
    <div className={classNames(className, 'cell growth-cell')} id={id ? `cell-${id}` : undefined} onClick={onClick}>
      <span className="markup-container">
        <IntegerValue growth value={value} isPercentage locale={locale} />
        {asteriskDisclaimerKey && <AsteriskDisclaimer disclaimerKey={asteriskDisclaimerKey} sectionKey={sectionKey} />}
        {hasDisclaimer && !asteriskDisclaimerKey && '*'}
        {disclaimerNumber && disclaimerKey && <NumberedDisclaimer disclaimerNumber={disclaimerNumber} disclaimerKey={disclaimerKey} sectionKey={sectionKey} />}
        {valueDisclaimer && <InfoTooltip title={valueDisclaimer.title} message={valueDisclaimer.message} list={valueDisclaimer.list} />}
      </span>
    </div>
  );
};

export default GrowthCell;
